import { render, staticRenderFns } from "./_IbxAssessmentPassageCard.vue?vue&type=template&id=995c7b1e"
import script from "./_IbxAssessmentPassageCard.vue?vue&type=script&lang=js"
export * from "./_IbxAssessmentPassageCard.vue?vue&type=script&lang=js"
import style0 from "./_IbxAssessmentPassageCard.vue?vue&type=style&index=0&id=995c7b1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports